import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenTitle from '../components/ScreenTitle';
import './privacy-policy.css';

export const TermsOfUse: React.FC = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="page">
      <ScreenTitle getHeaderTitle={() => "Terms of Use"} onBack={handleBack} />

      <div className="translations-content-container">
        <div className="container">

          <div className="tab-content translations-content-item en visible" id="en">

            <h1>Terms of Use</h1>
            <p>Last updated: November 5, 2025</p>

            <p>
              Please read these Terms of Use carefully before using the Flooron application or
              website. These Terms explain the rules and obligations between You and Flooron
              regarding Your use of Our Service.
            </p>

            <p>
              By accessing or using the Service You agree to be bound by these Terms. 
              If You disagree with any part of these Terms, You may not access the Service.
            </p>

            <h2>Interpretation and Definitions</h2>

            <h3>Definitions</h3>
            <ul>
              <li><p><strong>Application</strong> refers to Flooron.</p></li>
              <li><p><strong>Company</strong> refers to Flooron (“We”, “Us”, or “Our”).</p></li>
              <li><p><strong>Service</strong> refers to the Application.</p></li>
              <li><p><strong>You</strong> means the individual using the Service.</p></li>
              <li><p><strong>Account</strong> means an account created by You to access some parts of the Service.</p></li>
            </ul>

            <h2>User Responsibilities</h2>
            <p>Users agree not to misuse the Service. Misuse includes:</p>
            <ul>
              <li>Using the Service for unlawful purposes</li>
              <li>Attempting to gain unauthorized access to systems</li>
              <li>Any action that may harm Flooron, its users, or servers</li>
            </ul>

            <h2>Accounts</h2>
            <p>
              If You create an account, You are responsible for maintaining the confidentiality
              of login information and restricting access to Your device.
            </p>

            <h2>Intellectual Property</h2>
            <p>
              The Service and all related content including text, logos, graphics, and software
              remain the property of Flooron. You may not copy, modify, distribute, or reverse-engineer
              any part of the Service except where permitted by applicable law.
            </p>

            <h2>Links to Third-party Websites</h2>
            <p>
              Our Service may contain links to external websites. We do not control or endorse
              these external services and are not responsible for their content or policies.
            </p>

            <h2>Termination</h2>
            <p>
              We may suspend or terminate access to the Service immediately, without prior notice,
              for any breach of these Terms. Upon termination, Your right to use the Service will cease.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              To the extent permitted by applicable law, Flooron shall not be liable for any indirect,
              incidental, or consequential damages arising from use of the Service.
            </p>

            <h2>Changes to These Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the Service after changes means
              You agree to the updated Terms.
            </p>

            <h2>Contact Us</h2>
            <p>If you have any questions about these Terms, you can contact us at:</p>
            <ul>
              <li>By email: flooronindia@gmail.com</li>
            </ul>

          </div>
        </div>
      </div>

      <footer className="main-footer">
        <p>&copy; {new Date().getFullYear()} Flooron. All rights reserved.</p>
      </footer>

    </div>
  );
}

export default TermsOfUse;
